import styled from 'styled-components';

export const Wrap = styled.div`
    padding: 16px;
    border-radius: 8px;
    background: ${({ theme }) => theme.colors['Level 1']};
`;

export const Text = styled.p`
    ${({ theme }) => theme.typography.Paragraph};
    color: ${({ theme }) => theme.colors.Foreground};
`;
